import { getItemsIds } from '../../../utils/common'
import { TaskTableCellName } from '../Task.enums'

export function getAttachTasksModalTableColumns() {
  return {
    [TaskTableCellName.ActivityType]: {
      index: 2,
      name: TaskTableCellName.ActivityType,
      ordering_field: 'activity_type',
      title: 'Modal.AttachActivitiesColumnActivityTypeKey',
      visible: true,
      width: 160,
    },
    [TaskTableCellName.Deadline]: {
      index: 6,
      name: TaskTableCellName.Deadline,
      ordering_field: 'deadline',
      title: 'Modal.AttachActivitiesColumnDeadlineKey',
      visible: true,
      width: 192,
    },
    [TaskTableCellName.Manager]: {
      index: 5,
      name: TaskTableCellName.Manager,
      ordering_field: 'manager',
      title: 'Modal.AttachActivitiesColumnManagerKey',
      visible: true,
      width: 200,
    },
    [TaskTableCellName.Phase]: {
      index: 3,
      name: TaskTableCellName.Phase,
      ordering_field: 'phase',
      title: 'Modal.AttachActivitiesColumnPhaseKey',
      visible: true,
      width: 240,
    },
    [TaskTableCellName.Priority]: {
      index: 7,
      name: TaskTableCellName.Priority,
      ordering_field: 'priority',
      title: 'Modal.AttachActivitiesColumnPriorityKey',
      visible: true,
      width: 152,
    },
    [TaskTableCellName.Status]: {
      index: 0,
      name: TaskTableCellName.Status,
      ordering_field: 'status',
      title: 'Modal.AttachActivitiesColumnStatusKey',
      visible: true,
      width: 160,
    },
    [TaskTableCellName.Title]: {
      index: 1,
      name: TaskTableCellName.Title,
      ordering_field: 'title',
      title: 'Modal.AttachActivitiesColumnTitleKey',
      visible: true,
      width: 360,
    },
    [TaskTableCellName.VisibleToTenant]: {
      index: 4,
      name: TaskTableCellName.VisibleToTenant,
      ordering_field: 'visible_to_tenant',
      title: 'Modal.AttachActivitiesColumnVisibleToTenantKey',
      visible: true,
      width: 120,
    },
  }
}

export function getAttachTasksFromResponse(data) {
  return { items: data.items }
}

export function isEqualAttachTasksModal({ initialSelection, selected }) {
  if (selected.length !== initialSelection.length) {
    return false
  }

  const initialIdsSet = new Set(getItemsIds(initialSelection))

  return selected.every(item => initialIdsSet.has(item.id))
}
